import { makeAutoObservable, observable } from "mobx";

import { getCurrentUser } from "../../../Utility/modules/helpers";
import { MonthlySettingService } from "../services/monthlySettingService";

const _ = require("underscore");
class MonthlySettingStore {
  constructor() {
    makeAutoObservable(this);
  }

  hierarchy = observable.map({});
  isloading = false;
  selFieldId = "";
  selField = "";
  selWell = "";
  selWellId = "";
  fieldWells = [];
  selLevelId = "";
  selLevel = "";
 

  isSaving = false;
  monthlySettings = {};
  monthlySettingsLoaded = false;
  isSettingsModified = false;
  async loadHierarchy() {
    try {
      this.isloading = true;
      if(this.hierarchy.size===0){
        
        const res = await MonthlySettingService.loadHierarchy();
      this.hierarchy.clear();
      res.forEach((h) => {
        this.hierarchy.set(h.uniqueId, h);
      });
      }
      
    } catch (error) {
      throw error;
    } finally {
      this.isloading = false;
    }
  }

  async loadMonthlyDeckSettings() {
    try {
      if (!this.monthlySettingsLoaded) {
        const res = await MonthlySettingService.loadMonthlyDeckSettings();

        this.monthlySettingsLoaded = true;
        this.monthlySettings = res;
        //console.log(res);
      }
    } catch (error) {
      throw error;
    }
  }

  async saveMonthlyDeckSettings() {
    try {
      this.isSaving = true;
      const uploadedBy = getCurrentUser()?.fullName;
      const retval = await MonthlySettingService.saveMonthlyDeckSettings(
        this.monthlySettings,
        uploadedBy
      );
      return retval;
    } catch (error) {
      throw error;
    }
  }

  loadFieldWells(fieldId) {
    this.selWellId = "";
    this.fieldWells = [];
    const wellsObj=_.where(
          [...this.hierarchy.values()],
          { fieldId:fieldId }
        ).map((f) =>{return  {
            well:f.well,
            wellId:f.wellId
          }});
    const wells = _.uniq(
     
        wellsObj,
        "well",
        
     
    );
    this.fieldWells = [...wells];
  }

  async save() {
    try {
      this.isSaving = true;
      const hierarchy = {
        fieldId: this.selFieldId,
        wellId: this.selWellId,
        levelId: this.selLevelId,
        uniqueNo:`${this.selFieldId}${this.selWellId}${this.selLevelId}`,
        uniqueId: `${this.selField.split(" ").join("_")}_${this.selWell}_${
          this.selLevel
        }`,
      };
      const res = await MonthlySettingService.saveHierarchy(hierarchy);
      console.log(res);
      return res;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }
  clearHierarchyData() {
    this.selFieldId = "";
    this.selWellId = "";
    this.selLevelId = "";
    this.selField = "";
    this.selWell = "";
    this.selLevel = "";
  }
}



const monthlySettingStore = new MonthlySettingStore();

export default monthlySettingStore;

